<template>
  <div >
    <RequiredText />
    <Input
        :name="`${id}-name`"
        :label="$t('crm.label.label')"
        :placeholder="$t('crm.label.label')"
        v-model="formData.title"
    />
    <Select2
        :parent-id="`#${id}`"
        :multiple="false"
        :name="`${id}-call-priority`"
        :label="$t('crm.label.priority')"
        :placeholder-text="$t('crm.label.select_priority')"
        v-model="formData.priority"
    >
      <option v-for="(priority, index) in opportunityPriorityEnum" :value="priority.value" :key="index" >
        {{ priority[locale] }}
      </option>
    </Select2>
    <InputDate2
        :name="`${id}-call-date`"
        size="md"
        dateFormat="dd-MM-yyyy"
        :label="$t('crm.label.date')"
        v-model="formData.date"
        :placeholder="$t('crm.label.date')"
    />
    <div class="row">
      <div class="col-6">
        <Input
            :name="`${id}-call-time`"
            type="time"
            :label="$t('crm.label.time')"
            v-model="formData.time"
            :placeholder="$t('crm.label.time')"
        />
      </div>
      <div class="col-6">
        <Input
            type="time"
            :name="`${id}-call-duration`"
            :label="$t('crm.label.duration')"
            :placeholder="$t('crm.label.duration')"
            v-model="formData.duration"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Input from "@/components/Input.vue";
import InputDate2 from "@/components/InputDate2.vue";
import Select2 from "@/components/Select2.vue";
import {useLocales} from "@/composables/locales";

const { locale } = useLocales()
const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    default: {
      title: null,
      priority: null,
      datetime: null,
      duration: null,
      note: '',
    }
  },
  id: {
    type: String,
    required: true
  }
})

const formData = ref(props.form)

const opportunityPriorityEnum = computed(() => store.getters['pipelines/pipelinePriorityEnum'])




</script>

<style scoped>

</style>
